import brakes from '~/assets/icons/brakes_2.svg';
import carSeat from '~/assets/icons/car_seat.svg';
import paint from '~/assets/icons/paint_3.svg';
import paintingWheel from '~/assets/icons/painting_wheel.svg';
// import glassTinting from '~/assets/icons/glass_tinting.svg';

export enum CategoryTypes {
	PaintingWorks = 'PaintingWorks',
	PaintingInterior = 'PaintingInterior',
	PaintingWheels = 'PaintingWheels',
	GlassTinting = 'GlassTinting',
	Brakes = 'Brakes',
}

export const colorSelectItems = [
	{ type: CategoryTypes.PaintingWorks, icon: paint, name: 'Цвет кузова' },
	{ type: CategoryTypes.PaintingInterior, icon: carSeat, name: 'Цвет салона' },
	{
		type: CategoryTypes.PaintingWheels,
		icon: paintingWheel,
		name: 'Цвет дисков',
	},
	{ type: CategoryTypes.Brakes, icon: brakes, name: 'Тормозные суппорта' },
	// {icon: glassTinting, name: 'Тонировка стёкл'},
];
